//=================================================
//    summary: DCP 登入 視窗 -- Hook
//
//    remarks: 000 Tim 2021/12/23 增加註解 
//             001 Tim 2021/12/23 加入 PaintedMe流程
//             002 Tim 2022/11/02 加入 多重登入 阻擋視窗 機制
//================================================
import React, { useState, useEffect, useRef } from 'react'
import cssMain from './Main.module.scss'

import * as WebDataAccess from '../Utils/WebDataAccess'
import {LoadingMask, AlertWindow, CredentialMultiInWindow, ClientGatewayInPackage, AAALibs, GlobalLibs, NetworkLibs, LocalStorageLibs, RoutePathLibs} from 'bc-react-package'

// #region Member Variables
let mblnInitialized = false
// #endregion Member Variables

const COMP_NAME = "Main"

function Main(props)
{
    console.log(COMP_NAME + ".Begin: ", props)

    // #region Init State
    const [showLoadingMask, setShowLoadingMask] = useState(false)
    const [loadingMaskMessage, setLoadingMaskMessage] = useState("")
    const [showAlert, setShowAlert] = useState(false)
    const [alertObject, setAlertObject] = useState(null)
    const [showCredentialMultiIn, setShowCredentialMultiIn] = useState(false)
    const [credentialMultiInArguments, setCredentialMultiInArguments] = useState(null)
    // #endregion Init State

    // #region Init Ref
    let mrefPaintedMe = useRef(null)
    let mrefCleanUp = useRef(null)

    mrefPaintedMe.current = PaintedMe
    mrefCleanUp.current = CleanUp
    // #endregion Init Ref

    window.ComponentFuncEntry.MainRef = ComponentFuncEntry
    AAALibs.RegisterFuncRef4MainPageComponentFuncEntry(ComponentFuncEntry)

    // #region First Launch
    if (!mblnInitialized)
    {
        mblnInitialized = true
    }

    useEffect(() => {
        console.log(COMP_NAME + ".useEffect")
        
        mrefPaintedMe.current()
        return () => {
            console.log(COMP_NAME + ".cleanup")
            mrefCleanUp.current()
        }
    }, [props.location]) // end of useEffect

    // #region Painted Me
    function PaintedMe()
    {
        console.log(COMP_NAME + ".PaintedMe")
        let objWindowRefs = {
            OpenLoadingMask: OpenLoadingMask,
            CloseLoadingMask: CloseLoadingMask,
            ShowAlert: ShowAlert,
            ShowCredentialMultiInWindow: ShowCredentialMultiInWindow
        }
        // AAALibs.RegisterCallerWindownFuncRefs(objWindowRefs)
        GlobalLibs.RegisterCallerWindownFuncRefs(objWindowRefs)

        console.log("ClientGatewayInPackage: ", ClientGatewayInPackage)
        console.log("GlobalLibs: ", GlobalLibs)
        console.log("NetworkLibs: ", NetworkLibs)
        GetKeys4Systems()
    } // end of PaintedMe

    function CleanUp() { 
        console.log(COMP_NAME + ".CleanUp: ")

        // AAALibs.UnRegisterCallerWindownFuncRefs()
        GlobalLibs.UnRegisterCallerWindownFuncRefs()
        
        mblnInitialized = false
    }
    // #endregion Painted Me

    
    // #region LoadingMask Functions
    function OpenLoadingMask(LoadingMsg)
    {
        console.log(COMP_NAME + ".OpenLoadingMask")
        setShowLoadingMask(true)
        setLoadingMaskMessage(LoadingMsg)
    } // end of OpenLoadingMask
    
    function CloseLoadingMask()
    {
        console.log(COMP_NAME + ".CloseLoadingMask")
        setShowLoadingMask(false)
        setLoadingMaskMessage("")
    } // end of CloseLoadingMask
    
    function ShowAlert(AlertObject)
    {
        console.log(COMP_NAME + ".ShowAlertMain")
        setShowAlert(true)
        setAlertObject(AlertObject)
    }

    function HideAlert()
    {
        console.log(COMP_NAME + ".HideAlert")
        setShowAlert(false)
        setAlertObject(null)
    }

    /*===========================================
    summary: 開啟 多重登入 阻擋視窗
    remarks: 000 Tim 2022/11/02 Create
    ===========================================*/
    function ShowCredentialMultiInWindow(Title, Message)
    {
        let objCredentialMultiInArguments = {
            "Title": Title,
            "Message": Message
        }
        setCredentialMultiInArguments(objCredentialMultiInArguments)
        setShowCredentialMultiIn(true)
    } // end of ShowCredentialMultiInWindow
    // #endregion LoadingMask Functions

    // #region ComponentFuncEntry
    // richard: 20200722 Main 只提供這個入口給大家 Call    
    function ComponentFuncEntry(CallObject)
    {
        console.log(COMP_NAME + ".ComponentFuncEntry: ", CallObject)
        
        if (CallObject.Func === "ReLoginProcess")
        {
            ReLoginProcess(CallObject.LoginName, CallObject.Password)
        }
        else if (CallObject.Func === "LoginFailed")
        {
            LoginFinished(false)
        }
        else if (CallObject.Func === "LoginSuccess")
        {
            LoginFinished(true)
        }
        else if (CallObject.Func === "NewLoginProcess")
        {
            NewLoginProcess()
        }
        else if (CallObject.Func === "GetPrerequisiteDataEnd")
        {
            GetPrerequisiteDataProcessEnd()
        }
        else if (CallObject.Func === "CredentialErrContinue")
        {
            CredentialErrContinueProcess()
        }
        else
        {
            console.log("unspported func: ", CallObject.Func)
        }
    } // end of ComponentFuncEntry
    // #endregion ComponentFuncEntry

    // #region Other Functions    

    /*===========================================
    summary: 取得 班級 索引
    remarks: 000 Tim 2021/11/01 Create
    ===========================================*/
    function GetClassIndex()
    {
        console.log(COMP_NAME + ".GetClassIndex ClassName4Login:", window.gSession.Acc.ClassName4Login)

        if (window.gSession.Acc.ClassName4Login === "")
        {
            // 讀取暫存班級
            let intClassIndexLS = LocalStorageLibs.GetAccLSElement("CurrentClassIndex")

            if (
                (intClassIndexLS >= 0) &&
                (window.gSession.Acc.Class !== null) &&
                (typeof(window.gSession.Acc.Class[intClassIndexLS]) !== 'undefined') &&
                (window.gSession.Acc.Class[intClassIndexLS] !== null)
                )
            {
                window.gSession.Acc.CurrentClassIndex = intClassIndexLS
            }
            else if (
                    (window.gSession.Acc.Class !== null) &&
                    (window.gSession.Acc.Class.length > 0)
                    )
            {
                // 改 預設選取 最後一個班級
                window.gSession.Acc.CurrentClassIndex = window.gSession.Acc.Class.length - 1
            }
            else
            {
                window.gSession.Acc.CurrentClassIndex = 0
            }
        }
        else
        {
            let intIndex = 0
            let intCount = window.gSession.Acc.Class.length
            let blnFound = false

            while ((!blnFound) && (intIndex < intCount))
            {
                if (window.gSession.Acc.Class[intIndex].ClassName.toLowerCase() === window.gSession.Acc.ClassName4Login.toLowerCase())
                {
                    window.gSession.Acc.CurrentClassIndex = intIndex
                    window.gSession.Acc.ClassName4Login = ""
                    blnFound = true
                }
                intIndex++
            } // end of while

            // 更新班級暫存
            LocalStorageLibs.SetAccLSElement("CurrentClassIndex", window.gSession.Acc.CurrentClassIndex)
        }
        console.log(COMP_NAME + ".GetClassIndex CurrentClassIndex: ", window.gSession.Acc.CurrentClassIndex)
    } // end of GetClassIndex

    // Project開啟時 就先取得所需取得的參數 e.g. Client ID of Google, Facebook, Apple.
    // Integration: /home/bc/integration/www/WebGateway/Keys4Systems/Sys_$SysType.json
    // Staging: /home/bc/staging/www/WebGateway/Keys4Systems/Sys_$SysType.json
    // Production: /home/bc/production/www/WebGateway/Keys4Systems/Sys_$SysType.json

    function ReLoginProcess(LoginName, Password)
    {
        console.log(COMP_NAME + ".ReLoginProcess: ", LoginName, Password)
        AAALibs.ReLogin(LoginName, Password)
    } // end of ReLoginProcess
    
    function NewLoginProcess()
    {
        console.log(COMP_NAME + ".NewLoginProcess")
        LoginProcess()
    } // end of NewLoginProcess

    /*===========================================
     summary: Credential過期 出錯 但要繼續，先將畫面回到 MainBG畫面，之後 再導回 Home頁，讓整個畫面初始化
     remarks: 000 Tim 2020/12/02 Create
     ===========================================*/
    function CredentialErrContinueProcess()
    {
        console.log(COMP_NAME + ".CredentialErrContinueProcess")
        RoutePathLibs.Route2Path(props.history, "/MainBG")
    } // end of CredentialErrContinueProcess
    // #endregion Other Functions
    
    function InitLibsBegin()
    {
        console.log(COMP_NAME + ".InitLibsBegin")
        // 1. InitGoogleOAuthLibBegin
        // 2. InitFBOAuthLibBegin       // 前端 不使用 FB Login 所以 Lib也不要去讀      Tim22.03.01
        // 3. InitAppleOAuthLibBegin
        // 4. this.InitLibsEnd()
        InitGoogleOAuthLibBegin()
    } // end of InitLibsBegin
    
    function InitLibsEnd()
    {
        console.log(COMP_NAME + ".InitLibsEnd")
        LoginProcess()
    } // end of InitLibsEnd
    
    function InitAppleOAuthLibBegin()
    {
        console.log(COMP_NAME + ".InitAppleOAuthLibBegin")
        if (
            (typeof(window.AppleOAuthLibs.Initialized) === 'undefined') ||
            (window.AppleOAuthLibs.Initialized === null) ||
            (!window.AppleOAuthLibs.Initialized)
        )
        {
            // Init Apple OAuth APIs
            var objCallbackFunc = AfterAppleOAuthInitedHanlder
            // var objCallObject = {"Me": this}
            var objCallObject = null
            
            if (window.gSession.App.InApp)
            {
                objCallbackFunc(objCallObject)
            }
            else
            {
                // Init Apple OAuth APIs
                // window.AppleOAuthLibs.Init(objCallbackFunc, objCallObject)
                window.AppleOAuthLibs.Init(window.gSession.App.Keys4Systems.AppleOAuth.CLIENT_ID, window.gSession.Acc.Credential, window.gSession.App.Env, process.env.REACT_APP_LOG_VERSION, objCallbackFunc, objCallObject)
            }
        }
        else
        {
            InitLibsEnd()
        }
    } // end of InitAppleOAuthLibBegin
    
    // // 前端 不使用 FB Login 所以 Lib也不要去讀      Tim22.03.01
    // function InitFBOAuthLibBegin()
    // {
    //     console.log(COMP_NAME + ".InitFBOAuthLibBegin")
    //     // Init FB OAuth APIs
    //     var objCallbackFunc = AfterFBOAuthInitedHanlder
        
    //     var objCallObject = null
    //     if (
    //         (typeof(window.FBOAuthLibs.Initialized) === 'undefined') ||
    //         (window.FBOAuthLibs.Initialized === null) ||
    //         (!window.FBOAuthLibs.Initialized)

    //     )
    //     {
    //         if (window.gSession.App.InApp)
    //         {
    //             objCallbackFunc(objCallObject)
    //         }
    //         else
    //         {
    //             // Init FB OAuth APIs
    //             window.FBOAuthLibs.Init(objCallbackFunc, objCallObject)
    //         }
    //     }
    //     else
    //     {
    //         InitAppleOAuthLibBegin()
    //     }
    // } // end of InitFBOAuthLibBegin
    
    function InitGoogleOAuthLibBegin()
    {
        console.log(COMP_NAME + ".InitGoogleOAuthLibBegin")
        let objCallbackFunc = AfterGoogleOAuthInitedHanlder
        // let objCallObject = {"Me": this}
        var objCallObject = null
        if (
            (typeof(window.GoogleOAuthLibs.Initialized) === 'undefined') ||
            (window.GoogleOAuthLibs.Initialized === null) ||
            (!window.GoogleOAuthLibs.Initialized)
            )
        {
            if (
                (window.gSession.App.InApp) ||
                (window.gConfig.ForChina)
                )
            {
                objCallbackFunc(objCallObject)
            }
            else
            {
                // Init Google OAuth APIs
                // window.GoogleOAuthLibs.Init(objCallbackFunc, objCallObject)
                window.GoogleOAuthLibs.Init(window.gSession.App.Keys4Systems.GoogleOAuth.CLIENT_ID, objCallbackFunc, objCallObject)
            }
        }
        else
        {
            // 前端 不使用 FB Login 所以 Lib也不要去讀      Tim22.03.01
            // InitFBOAuthLibBegin()

            InitAppleOAuthLibBegin()
        }
    } // end of InitGoogleOAuthLibBegin
    
    function AfterGoogleOAuthInitedHanlder(CallbackObj, Error)
    {
        console.log(COMP_NAME + ".AfterGoogleOAuthInitedHanlder: ", CallbackObj, Error)
        if (
            (typeof(Error) === 'undefined') ||
            (Error === null)
            )
        {
            // loading successfully
            console.log("Google OAuth Libs loaded successfully")
            window.GoogleOAuthLibs.Initialized = true
        }
        else
        {
            // loading sdk failed
            console.log("Google SDK Loaded Failed: ", Error)
        }
        
        // 前端 不使用 FB Login 所以 Lib也不要去讀      Tim22.03.01
        // InitFBOAuthLibBegin()

        InitAppleOAuthLibBegin()
    } // end of AfterGoogleOAuthInitedHanlder
    
    // // 前端 不使用 FB Login 所以 Lib也不要去讀      Tim22.03.01
    // function AfterFBOAuthInitedHanlder(CallbackObj, Error)
    // {
    //     console.log(COMP_NAME + ".AfterFBOAuthInitedHanlder")
    //     if (
    //         (typeof(Error) === 'undefined') ||
    //         (Error === null)
    //     )
    //     {
    //         // loading successfully
    //         console.log("FB OAuth Libs loaded successfully")
    //         window.FBOAuthLibs.Initialized = true
    //     }
    //     else
    //     {
    //         // loading sdk failed
    //         console.log("FB SDK Loaded Failed: ", Error)
    //     }
    //     // CallbackObj.Me.InitLibsEnd()
    //     // CallbackObj.Me.InitAppleOAuthLibBegin()
    //     InitAppleOAuthLibBegin()
    // } // end of AfterFBOAuthInitedHanlder
    
    function AfterAppleOAuthInitedHanlder(CallbackObj, Error)
    {
        console.log(COMP_NAME + ".AfterAppleOAuthInitedHanlder")
        if (
            (typeof(Error) === 'undefined') ||
            (Error === null)
        )
        {
            // loading successfully
            console.log("Apple OAuth Libs loaded successfully")
            window.AppleOAuthLibs.Initialized = true
        }
        else
        {
            // loading sdk failed
            console.log("Apple SDK Loaded Failed: ", Error)
        }
        // CallbackObj.Me.InitLibsEnd()
        InitLibsEnd()
    } // end of AfterAppleOAuthInitedHanlder
    
    // function ShowGlobalLoginFlog()
    // {
    //     console.log("window.gLoginFlag.HasQueryString: ", window.gLoginFlag.HasQueryString)
    //     console.log("window.gLoginFlag.PageIsInTheApp: ", window.gLoginFlag.PageIsInTheApp)
    //     console.log("window.gLoginFlag.LocalStorageContainLastAccountID: ", window.gLoginFlag.LocalStorageContainLastAccountID)
    //     console.log("window.gLoginFlag.LocalStorageContainCredentialIsValid: ", window.gLoginFlag.LocalStorageContainCredentialIsValid)
    //     console.log("window.gLoginFlag.LocalStorageContainLastLoginStatusIsOAuth: ", window.gLoginFlag.LocalStorageContainLastLoginStatusIsOAuth)
    //     console.log("window.gLoginFlag.LocalStorageContainLastLoginStatusIsOAuthAndAppleSignIn: ", window.gLoginFlag.LocalStorageContainLastLoginStatusIsOAuthAndAppleSignIn)
    //     console.log("window.gLoginFlag.LocalStorageContainLastAccountID_IsTheSameAs_CurrentAccountID: ", window.gLoginFlag.LocalStorageContainLastAccountID_IsTheSameAs_CurrentAccountID)
    //     console.log("window.gLoginFlag.NavigatorOnLine: ", window.gLoginFlag.NavigatorOnLine)
    // } // end of ShowGlobalLoginFlog
    
    function LoginProcess()
    {
        console.log(COMP_NAME + ".LoginProcess")
        // var intLastAccountID = 0
        // var strLastLoginName = ""
        // var strValidLastCredential = ""
        // AAA.ResetGlobalLoginFlag()
        // console.log("After reset window.gLoginFlag:", window.gLoginFlag)
        // ShowGlobalLoginFlog()
        console.log("window.gSession.App: ", window.gSession.App)
        console.log("window.gSession.App.InitCredential: ", window.gSession.App.InitCredential)
        
        if (window.gSession.App.InitCredential !== "")
        {
            // window.gLoginFlag.HasQueryString = true
            console.log("Launched by Other App or OLS: ", window.gSession.App.InitCredential, window.gSession.App.InitAccountID)
            LoginProcessWithInitCredential()
        } else // no credential in QueryString: not launched by BIReport App
        {
            // window.gLoginFlag.HasQueryString = false
            console.log("no credential in QueryString")
            // 先驗證 是否 是 Apple Login 等資訊     Tim20.02.10
            // 如果是 in App 且 是 Apple Login 就先去詢問 App 是否Apple帳號 還有效   Tim20.02.04
            
            if (window.gSession.App.InApp)
            {
                // window.gLoginFlag.PageIsInTheApp = true
                let intLastAccountID = LocalStorageLibs.GetAppLSElement("LastAccountID")
                console.log("LoginProcess: intLastAccountID: ", intLastAccountID)
                
                if (intLastAccountID !== 0)
                {
                    // window.gLoginFlag.LocalStorageContainLastAccountID = true
                    // window.gSession.Acc.ID = intLastAccountID
                    let blnIsOAuthLogin = LocalStorageLibs.GetAccLSElement("IsOAuthLogin")
                    console.log("LoginProcess: blnIsOAuthLogin: ", blnIsOAuthLogin)
                    
                    if (blnIsOAuthLogin)
                    {
                        // window.gLoginFlag.LocalStorageContainLastLoginStatusIsOAuth = true
                        let objOAuthLoginObject = LocalStorageLibs.GetAccLSElement("OAuthLoginObject")
                        console.log("LoginProcess: objOAuthLoginObject: ", objOAuthLoginObject)
                        if (
                            (typeof(objOAuthLoginObject) !== 'undefined') &&
                            (objOAuthLoginObject !== null) &&
                            (typeof(objOAuthLoginObject.LoginProvider) !== 'undefined') &&
                            (objOAuthLoginObject.LoginProvider !== null) &&
                            (parseInt(objOAuthLoginObject.LoginProvider) === 3) && // Apple 登入
                            (typeof(objOAuthLoginObject.userID) !== 'undefined') &&
                            (objOAuthLoginObject.userID !== null) &&
                            (objOAuthLoginObject.userID !== "")

                        )
                        {
                            // window.gLoginFlag.LocalStorageContainLastLoginStatusIsOAuthAndAppleSignIn = true
                            // HasQueryString:F
                            // PageIsInTheApp:T
                            // LocalStorageContainLastAccountID:T
                            // LocalStorageContainCredentialIsValid:T   OR    LocalStorageContainCredentialIsValid:F
                            // LocalStorageContainLastLoginStatusIsOAuth:T
                            // LocalStorageContainLastLoginStatusIsOAuthAndAppleSignIn:T
                            // LocalStorageContainLastAccountID_IsTheSameAs_CurrentAccountID:T/F
                            // NavigatorOnLine:T/F
                            // 是 Apple 登入 且 userID 有值
                            // 呼叫 App 確認 Apple登入資料 是否 還可以登入
                            CallAppCheckAppleLoginVerify4UserID(objOAuthLoginObject.userID)
                        }
                        else
                        {
                            // window.gLoginFlag.LocalStorageContainLastLoginStatusIsOAuthAndAppleSignIn = false
                            // 不是 Apple 或 userID 沒值，導回原本流程
                            LoginProcessWithoutInitCredential()
                        }
                    }
                    else
                    {
                        // window.gLoginFlag.LocalStorageContainLastLoginStatusIsOAuth = true
                        // 不是 OAuth Login，導回原本流程
                        LoginProcessWithoutInitCredential()
                    }
                }
                else
                {
                    // window.gLoginFlag.LocalStorageContainLastAccountID = false
                    // 沒 Login過，導回原本流程
                    window.gSession.Acc.ID = 0
                    LoginProcessWithoutInitCredential()
                }
            }
            else
            {
                // window.gLoginFlag.PageIsInTheApp = false
                // 不是 in App，導回原本流程
                LoginProcessWithoutInitCredential()
            }
        }
    } // end of LoginProcess
    
    /*===========================================
    summary: 
    remarks: 000 Jeff 20XX/XX/XX Create
             001 Tim 2023/06/19 處理 AppCallbackRef 反註冊
             002 Tim 2023/08/18 改寫 ClientGatewayInPackage.CallApp(
                                參數 要改用 最新版本 QueryString, CallbackFuncRef
    ===========================================*/
    function CallAppCheckAppleLoginVerify4UserID(UserID)
    {
        console.log(COMP_NAME + ".CallAppCheckAppleLoginVerify4UserID: ")
        // console.log(COMP_NAME + ".CallAppCheckAppleLoginVerify4UserID window.gLoginFlag:", window.gLoginFlag)
        // ShowGlobalLoginFlog()

        var intAction = window.gConst.ACTION_CHECK_APPLE_LOGIN_VERIFY
        var strQueryString = "Action=" + intAction + "&Credential=&BackRoute="
        strQueryString += "&UserID=" + UserID

        // need to call app
        console.log(COMP_NAME + ".CallAppCheckAppleLoginVerify4UserID strQueryString: ", strQueryString)

        // ClientGatewayInPackage.CallApp(strQueryString, window.CallAppAPI, window.gSession.App.InApp, window.gSession.App.iOSNewGateway, BackFromCheckAppleLoginVerify4UserID)
        ClientGatewayInPackage.CallApp(strQueryString, BackFromCheckAppleLoginVerify4UserID)
    } // end of CallAppCheckAppleLoginVerify4UserID

    // remarks: 001 Tim 2023/06/19 處理 AppCallbackRef 反註冊
    function BackFromCheckAppleLoginVerify4UserID(ReturnData)
    {
        const FUNC_NAME = "BackFromCheckAppleLoginVerify4UserID"
        console.log(COMP_NAME + "." + FUNC_NAME + ": ", ReturnData)

        // 判斷授權是否還存在
        // 使用者 可在手機"設定"裡關閉給我們App的授權 所以每次開App時 需用此API判斷 授權是否還存在
        // CredentialState:
        // 1: authorized
        // -1: revoked      授權取消
        // -2: notFound     AppleID登出
        if (
            (typeof(ReturnData) !== 'undefined') &&
            (ReturnData !== null) &&
            (typeof(ReturnData.CredentialState) !== 'undefined') &&
            (ReturnData.CredentialState !== null) &&
            (parseInt(ReturnData.CredentialState) === 1)

        )
        {
            // 驗證有效，導回原本流程
            LoginProcessWithoutInitCredential()
        }
        else
        {
            // 驗證無效，導回 登入畫面 Login Page
            GoToLoginPage()
        }

        // window.gSession.App.AppCallbackRef = null
    } // end of BackFromCheckAppleLoginVerify4UserID
    
    function LoginProcessWithInitCredential()
    {
        console.log(COMP_NAME + ".LoginProcessWithInitCredential")
        var intLastAccountID = 0
        // var strLastLoginName = ""
        var strValidLastCredential = ""
        // launch by Other App, 20191002 is for Clever
        
        if (AAALibs.CheckIfLastAccountID(window.gSession.App.InitAccountID))
        {
            // window.gLoginFlag.LocalStorageContainLastAccountID_IsTheSameAs_CurrentAccountID = true
            console.log("Found last login in LS")
            // window.gSession.Acc.ID = window.gSession.App.InitAccountID
            intLastAccountID = LocalStorageLibs.GetAppLSElement("LastAccountID")
            // last login
            // strValidLastCredential = utilGlobals.CheckAndGetLastSessionStillValid(gSession.App.InitLoginName)
            strValidLastCredential = AAALibs.CheckAndGetLastSessionStillValid4AccountID(window.gSession.App.InitAccountID)
            
            if (strValidLastCredential !== "")
            {
                // window.gLoginFlag.LocalStorageContainCredentialIsValid = true
                // valid credential
                console.log("Local credential with SysType is not expired")
                LoginProcessWithLSValidCredential(intLastAccountID)
            }
            else
            {
                // window.gLoginFlag.LocalStorageContainCredentialIsValid = false
                // no valid credential
                console.log("Local credential with SysType is expired, need to credential login")
                // credential login
                
                if (!navigator.onLine && window.gSession.App.InApp)
                {
                    // window.gLoginFlag.NavigatorOnLine = false
                    // window.gLoginFlag.PageIsInTheApp = true
                    console.log("network offline and In App, try to Acc0Login!")
                    GoToLoginPage()
                }
                else
                {
                    // window.gLoginFlag.NavigatorOnLine = true
                    // HasQueryString:T
                    // PageIsInTheApp:T/F
                    // LocalStorageContainLastAccountID:T/F
                    // LocalStorageContainCredentialIsValid:F
                    // LocalStorageContainLastLoginStatusIsOAuth:T/F
                    // LocalStorageContainLastLoginStatusIsOAuthAndAppleSignIn:T/F
                    // LocalStorageContainLastAccountID_IsTheSameAs_CurrentAccountID:T
                    // NavigatorOnLine:T
                    console.log("network online, try to credential login!")
                    AAALibs.CredentialLogin(window.gSession.App.InitCredential)
                }
            }
        }
        else
        {
            // window.gLoginFlag.LocalStorageContainLastAccountID_IsTheSameAs_CurrentAccountID = false
            // not last login, use this Credential  to credential login
            console.log("AccountID not found in LS, a new login name try to CredentialLogin")
            // credential login
            
            if (!navigator.onLine && window.gSession.App.InApp)
            {
                // window.gLoginFlag.NavigatorOnLine = false
                // window.gLoginFlag.PageIsInTheApp = true
                console.log("network offline and In App, try to open Login!")
                GoToLoginPage()
            }
            else
            {
                // window.gLoginFlag.NavigatorOnLine = true
                console.log("network online, try to credential login!")
                AAALibs.CredentialLogin(window.gSession.App.InitCredential)
            }
        }
        // console.log("window.gLoginFlag:", window.gLoginFlag)
        // ShowGlobalLoginFlog()
    } // End of LoginProcessWithInitCredential
    
    function LoginProcessWithoutInitCredential()
    {
        console.log(COMP_NAME + ".LoginProcessWithoutInitCredential")
        var intLastAccountID = 0
        // var strLastLoginName = ""
        var strValidLastCredential = ""
        intLastAccountID = LocalStorageLibs.GetAppLSElement("LastAccountID")
        console.log("intLastAccountID: ", intLastAccountID)
        
        if (intLastAccountID !== 0)
        {
            // window.gLoginFlag.LocalStorageContainLastAccountID = true
            // window.gSession.Acc.ID = intLastAccountID
            // 有上次的 Login
            // 找看看 LS 裡面的 Credential 是不是還 Valid, 如果 Valid, 就不需要到 Backend 再 Login 一次
            strValidLastCredential = AAALibs.CheckAndGetLastSessionStillValid4AccountID(intLastAccountID)
            console.log("strValidLastCredential: ", strValidLastCredential)
            
            if (strValidLastCredential !== "")
            {
                // window.gLoginFlag.LocalStorageContainCredentialIsValid = true
                // LS Credential 有效，不需登入 走後續流程  // valid credential
                console.log("App Local credential with SysType is not expired")
                if (!window.gSession.App.InApp)
                // if (
                //     !window.gSession.App.InApp ||
                //     (Ext.os.name === "Android")
                //     )
                {
                    // window.gLoginFlag.PageIsInTheApp = false
                    console.log("not in app!")
                    let blnIsOAuthLogin = LocalStorageLibs.GetAccLSElement("IsOAuthLogin")
                    console.log("blnIsOAuthLogin: ", blnIsOAuthLogin)
                    
                    if (blnIsOAuthLogin)
                    {
                        // window.gLoginFlag.LocalStorageContainLastLoginStatusIsOAuth = true
                        console.log("Not In App and OAuth Login and Credential is Valid")
                        // var objOAuthLoginObject = JSON.parse(LocalStorageLibs.GetAccLSElement("OAuthLoginObject"))
                        let objOAuthLoginObject = LocalStorageLibs.GetAccLSElement("OAuthLoginObject")
                        console.log("objOAuthLoginObject: ", objOAuthLoginObject)
                        console.log("objOAuthLoginObject.accessToken: ", objOAuthLoginObject.accessToken)
                        AAALibs.OAuthLSValidCredentialLogin(intLastAccountID, objOAuthLoginObject)
                    }
                    else
                    {
                        // window.gLoginFlag.LocalStorageContainLastLoginStatusIsOAuth = false
                        console.log("Not In App and NOT OAuth Login and Credential is Valid")
                        AAALibs.LSValidCredentialLogin(intLastAccountID, "")
                    }
                }
                else
                {
                    // window.gLoginFlag.PageIsInTheApp = true
                    console.log("in app")
                    let blnIsOAuthLogin = LocalStorageLibs.GetAccLSElement("IsOAuthLogin")
                    console.log("blnIsOAuthLogin: ", blnIsOAuthLogin)
                    
                    if (blnIsOAuthLogin)
                    {
                        // window.gLoginFlag.LocalStorageContainLastLoginStatusIsOAuth = true
                        // HasQueryString:F
                        // PageIsInTheApp:T
                        // LocalStorageContainLastAccountID:T
                        // LocalStorageContainCredentialIsValid:T
                        // LocalStorageContainLastLoginStatusIsOAuth:T
                        // LocalStorageContainLastLoginStatusIsOAuthAndAppleSignIn:F
                        // LocalStorageContainLastAccountID_IsTheSameAs_CurrentAccountID:T/F
                        // NavigatorOnLine:T/F
                        console.log("LoginProcessWithoutInitCredential: In App and OAuth Login and Credential is Valid")
                        let objOAuthLoginObject = LocalStorageLibs.GetAccLSElement("OAuthLoginObject")
                        console.log("objOAuthLoginObject: ", objOAuthLoginObject)
                        // console.log("objOAuthLoginObject.authenticationToken: ", objOAuthLoginObject.authenticationToken)
                        AAALibs.OAuthLSValidCredentialLogin(intLastAccountID, objOAuthLoginObject)
                    }
                    else
                    {
                        // window.gLoginFlag.LocalStorageContainLastLoginStatusIsOAuth = false
                        console.log("In App and NOT OAuth Login and Credential is Valid")
                        GetPasswordFromApp4LSValidCredentialLogin()
                    }
                    // and then LSValidCredentialLogin
                }
            } 
            else // AccountID !== 0 && strValidLastCredential === ''
            {
                // window.gLoginFlag.LocalStorageContainCredentialIsValid = false
                // 有 Last Account ID， 但 LS 的 Credential 已經不是 Valid
                console.log("有 Last Account ID， 但 LS 的 Credential 已經不是 Valid, Expired")
                
                if (window.gSession.App.InApp)
                {
                    // window.gLoginFlag.PageIsInTheApp = true
                    let blnIsOAuthLogin = LocalStorageLibs.GetAccLSElement("IsOAuthLogin")
                    console.log("blnIsOAuthLogin: ", blnIsOAuthLogin)
                    
                    if (blnIsOAuthLogin)
                    {
                        // window.gLoginFlag.LocalStorageContainLastLoginStatusIsOAuth = true
                        // HasQueryString:F
                        // PageIsInTheApp:T
                        // LocalStorageContainLastAccountID:T
                        // LocalStorageContainCredentialIsValid:F
                        // LocalStorageContainLastLoginStatusIsOAuth:T
                        // LocalStorageContainLastLoginStatusIsOAuthAndAppleSignIn:F
                        // LocalStorageContainLastAccountID_IsTheSameAs_CurrentAccountID:T/F
                        // NavigatorOnLine:T/F
                        let objOAuthLoginObject = LocalStorageLibs.GetAccLSElement("OAuthLoginObject")
                        
                        if (objOAuthLoginObject.LoginProvider === AAALibs.OAuthProviderTypeEnum.Facebook)
                        {
                            CallAppRegisterWithFB()
                        
                        }
                        else if (objOAuthLoginObject.LoginProvider === AAALibs.OAuthProviderTypeEnum.Google)
                        {
                            CallAppRegisterWithGoogle()
                        }
                        else
                        {
                            CallAppRegisterWithApple(objOAuthLoginObject)
                        }
                    }
                    else
                    {
                        // window.gLoginFlag.LocalStorageContainLastLoginStatusIsOAuth = false
                        // 走 Auto Login 了
                        GetPasswordFromApp4AutoLogin()
                    }
                }
                else
                {
                    // window.gLoginFlag.PageIsInTheApp = false
                    console.log("Not InApp, 有 Last Account ID， 但 LS 的 Credential 已經不是 Valid, Expired") // In Web, 沒有存 Password, 直接 Login Page
                    // 沒有任何 Login
                    GoToLoginPage()
                }
            }
            // window.gSession.Acc.ID = intLastAccountID
            // this.GotoMain()                
        }
        else
        {
            // window.gLoginFlag.LocalStorageContainLastAccountID = false
            // 沒有任何 Login
            GoToLoginPage()
        }
        // console.log("window.gLoginFlag:", window.gLoginFlag)
        // ShowGlobalLoginFlog()
    } // end of LoginProcessWithoutInitCredential
    
    function CallAppRegisterWithApple(OAuthLoginObject)
    {
        console.log(COMP_NAME + ".CallAppRegisterWithApple OAuthLoginObject: ", OAuthLoginObject)
        // let strUserID = ""
        if (
            (typeof(OAuthLoginObject) !== 'undefined') &&
            (OAuthLoginObject !== null) &&
            (typeof(OAuthLoginObject.userID) !== 'undefined') &&
            (OAuthLoginObject.userID !== null) &&
            (OAuthLoginObject.userID !== "")

        )
        {
            AAALibs.OAuthLogin(OAuthLoginObject, AAALibs.OAuthProviderTypeEnum.Apple)
        }
        else
        {
            GoToLoginPage()
        }
    } // end of CallAppRegisterWithApple
    
    /*===========================================
    summary: 
    remarks: 000 Jeff 20XX/XX/XX Create
             001 Tim 2023/06/19 處理 AppCallbackRef 反註冊
             002 Tim 2023/08/18 改寫 ClientGatewayInPackage.CallApp(
                                參數 要改用 最新版本 QueryString, CallbackFuncRef
    ===========================================*/
    function CallAppRegisterWithFB()
    {
        const FUNC_NAME = "CallAppRegisterWithFB"
        console.log(COMP_NAME + "." + FUNC_NAME + ": ")

        let intAction = window.gConst.ACTION_OAUTH_FB_REG
        let strQueryString = "Action=" + intAction
        strQueryString += "&Credential="
        strQueryString += "&BackRoute="

        // need to call app
        console.log(COMP_NAME + "." + FUNC_NAME + " strQueryString: ", strQueryString)
        
        // ClientGatewayInPackage.CallApp(strQueryString, window.CallAppAPI, window.gSession.App.InApp, window.gSession.App.iOSNewGateway, BackFromAppCallbackRegisterWithFB)
        ClientGatewayInPackage.CallApp(strQueryString, BackFromAppCallbackRegisterWithFB)
    } // end of CallAppRegisterWithFB

    // remarks: 001 Tim 2023/06/19 處理 AppCallbackRef 反註冊
    function BackFromAppCallbackRegisterWithFB(ReturnData, CallbackObj)
    {
        console.log(COMP_NAME + ".BackFromAppCallbackRegisterWithFB: ", ReturnData, CallbackObj)
        AAALibs.OAuthLogin(ReturnData, AAALibs.OAuthProviderTypeEnum.Facebook)

        // window.gSession.App.AppCallbackRef = null
    } // end of BackFromAppCallbackRegisterWithFB
    
    /*===========================================
    summary: 
    remarks: 000 Jeff 20XX/XX/XX Create
             001 Tim 2023/06/19 處理 AppCallbackRef 反註冊
             002 Tim 2023/08/18 改寫 ClientGatewayInPackage.CallApp(
                                參數 要改用 最新版本 QueryString, CallbackFuncRef
    ===========================================*/
    function CallAppRegisterWithGoogle()
    {
        const FUNC_NAME = "CallAppRegisterWithGoogle"
        console.log(COMP_NAME + "." + FUNC_NAME + ": ")

        let intAction = window.gConst.ACTION_OAUTH_GOOGLE_REG
        let strQueryString = "Action=" + intAction
        strQueryString += "&Credential="
        strQueryString += "&BackRoute="

        // need to call app
        console.log(COMP_NAME + "." + FUNC_NAME + " strQueryString: ", strQueryString)
        
        // ClientGatewayInPackage.CallApp(strQueryString, window.CallAppAPI, window.gSession.App.InApp, window.gSession.App.iOSNewGateway, BackFromAppCallbackRegisterWithGoogle)
        ClientGatewayInPackage.CallApp(strQueryString, BackFromAppCallbackRegisterWithGoogle)
    } // end of CallAppRegisterWithGoogle

    // remarks: 001 Tim 2023/06/19 處理 AppCallbackRef 反註冊
    function BackFromAppCallbackRegisterWithGoogle(ReturnData, CallbackObj)
    {
        const FUNC_NAME = "BackFromAppCallbackRegisterWithGoogle"
        console.log(COMP_NAME + "." + FUNC_NAME + ": ", ReturnData, CallbackObj)

        AAALibs.OAuthLogin(ReturnData, AAALibs.OAuthProviderTypeEnum.Google)
        // window.gSession.App.AppCallbackRef = null
    } // end of BackFromAppCallbackRegisterWithGoogle
    
    function LoginProcessWithLSValidCredential(AccountID)
    {
        console.log(COMP_NAME + ".LoginProcessWithLSValidCredential: ", AccountID)
        let intLastAccountID = AccountID
        
        if (!window.gSession.App.InApp)
        {
            // window.gLoginFlag.PageIsInTheApp = false
            console.log("not in app!")
            var blnIsOAuthLogin = LocalStorageLibs.GetAccLSElement("IsOAuthLogin")
            console.log("blnIsOAuthLogin: ", blnIsOAuthLogin)
            
            if (blnIsOAuthLogin)
            {
                // window.gLoginFlag.LocalStorageContainLastLoginStatusIsOAuth = true
                console.log("OAuth Login and Not In App and Credential is Valid")
                let objOAuthLoginObject = LocalStorageLibs.GetAccLSElement("OAuthLoginObject")
                // console.log("objOAuthLoginObject: ", objOAuthLoginObject)
                // console.log("objOAuthLoginObject.authenticationToken: ", objOAuthLoginObject.authenticationToken)
                AAALibs.OAuthLSValidCredentialLogin(intLastAccountID, objOAuthLoginObject)
            }
            else
            {
                // window.gLoginFlag.LocalStorageContainLastLoginStatusIsOAuth = false
                console.log("Not In App and NOT OAuth Login and Credential is Valid")
                AAALibs.LSValidCredentialLogin(intLastAccountID, "")
            }
        }
        else
        {
            // window.gLoginFlag.PageIsInTheApp = true
            console.log("in app")
            let blnIsOAuthLogin = LocalStorageLibs.GetAccLSElement("IsOAuthLogin")
            console.log("blnIsOAuthLogin: ", blnIsOAuthLogin)
            
            if (blnIsOAuthLogin)
            {
                // window.gLoginFlag.LocalStorageContainLastLoginStatusIsOAuth = true
                console.log("In App and OAuth Login and Credential is Valid")
                let objOAuthLoginObject = LocalStorageLibs.GetAccLSElement("OAuthLoginObject")
                // console.log("objOAuthLoginObject: ", objOAuthLoginObject)
                // console.log("objOAuthLoginObject.authenticationToken: ", objOAuthLoginObject.authenticationToken)
                AAALibs.OAuthLSValidCredentialLogin(intLastAccountID, objOAuthLoginObject)
            }
            else
            {
                // window.gLoginFlag.LocalStorageContainLastLoginStatusIsOAuth = false
                console.log("In App and NOT OAuth Login and Credential is Valid")
                GetPasswordFromApp4LSValidCredentialLogin()
            }
        }
    } // end of LoginProcessWithLSValidCredential
    
    // remarks: 001 Tim 2023/06/19 處理 AppCallbackRef 反註冊
    function GetPasswordFromApp4LSValidCredentialLogin()
    {
        console.log(COMP_NAME + ".GetPasswordFromApp4LSValidCredentialLogin")
        GlobalLibs.GetEncriptedData("Password", GetPasswordFromApp4LSValidCredentialLoginCallback)
    } // end of GetPasswordFromApp4LSValidCredentialLogin

    // remarks: 001 Tim 2023/06/19 處理 AppCallbackRef 反註冊
    function GetPasswordFromApp4LSValidCredentialLoginCallback(ReturnData)
    {
        console.log(COMP_NAME + ".GetPasswordFromApp4LSValidCredentialLoginCallback: ", ReturnData)

        // window.gSession.App.AppCallbackRef = null

        var intLastAccountID = LocalStorageLibs.GetAppLSElement("LastAccountID")
        var strPassword = ReturnData.Value
        // 跨App登入 有可能取不到 Password，但還是要讓他走 CredentialLogin 流程
        // 參考DCP作法，有諮詢Richard     Tim20.04.29
        AAALibs.LSValidCredentialLogin(intLastAccountID, strPassword)
    } // end of GetPasswordFromApp4LSValidCredentialLoginCallback
    
    // remarks: 001 Tim 2023/06/19 處理 AppCallbackRef 反註冊
    function GetPasswordFromApp4AutoLogin()
    {
        console.log(COMP_NAME + ".GetPasswordFromApp4AutoLogin")
        GlobalLibs.GetEncriptedData("Password", GetPasswordFromApp4AutoLoginCallback)
    } // end of GetPasswordFromApp4AutoLogin
    
    // remarks: 001 Tim 2023/06/19 處理 AppCallbackRef 反註冊
    function GetPasswordFromApp4AutoLoginCallback(ReturnData)
    {
        console.log(COMP_NAME + ".GetPasswordFromApp4AutoLoginCallback: ", ReturnData)

        // window.gSession.App.AppCallbackRef = null

        let strLastLoginName = LocalStorageLibs.GetAccLSElement("LoginName")
        let strPassword = ReturnData.Value
        if (
            (strLastLoginName !== "") &&
            (strPassword !== "")

        )
        {
            AAALibs.AutoLogin(strLastLoginName, strPassword)
        }
        else
        {
            // Data Inconsistent
            // 就直接 Login 
            GoToLoginPage()
        }
    } // end of GetPasswordFromApp4AutoLoginCallback
    
    // richard 20230804 當 Login Success 之後， 各個 Application 應該有自己的 LS, Global Variables 要處理
    function SetApplicationRelatedVariablesAfterLogin()
    {
        const FUNC_NAME = "SetApplicationRelatedVariablesAfterLogin"
        console.log(COMP_NAME + "." + FUNC_NAME + ":")
        
        console.log(COMP_NAME + "." + FUNC_NAME + " window.gSession.Acc:", window.gSession.Acc)

        if (AAALibs.LoginInfo.LoginType === AAALibs.LoginTypeEnum.ValidCredentialLogin)
        {
            console.log("ValidCredentialLogin")
            // richard 20230804 remove (與Tim討論需要把這部分移到外面)
            let strTipCount = LocalStorageLibs.GetAccLSElement("TipCount")
            console.log("strTipCount: ", strTipCount)
            if (
                (strTipCount !== null) &&
                (strTipCount !== "") &&
                (parseInt(strTipCount) >= 0)
                )
            {
                window.gSession.Acc.TipCount = parseInt(strTipCount)
            }
        }
    }
    function LoginFinished(Success)
    {
        console.log(COMP_NAME + ".LoginFinished: ", Success)
        console.log("props.history: ", props.history)
        
        if (Success)
        {
            // 針對每個 Application 有自己的的 LS, Variables 要設定，例如 DCP 有 TipCounts
            SetApplicationRelatedVariablesAfterLogin()
            // begin to get book category and book data
            GetPrerequisiteDataProcessBegin()
        }
        else
        {
            GoToLoginPage()
        }
    } // end of LoginFinishedEnd
    
    function GoToLoginPage()
    {
        console.log(COMP_NAME + ".GoToLoginPage")
        let strLoginPagePathName = "/Login" // Production
        // let strLoginPagePathName = "/SignUp"
        // let strLoginPagePathName = "/SignUpSchoolInfo"
        // let strLoginPagePathName = "/SignUpTeacherPermissionRequest"
        // let strLoginPagePathName = "/SignUpParent"
        // let strLoginPagePathName = "/SendMailVerification"
        // let strLoginPagePathName = "/EmailVerified"
        // let strLoginPagePathName = "/SelectRole"
        // let strLoginPagePathName = "/ResendMailVerification"
        // let strLoginPagePathName = "/MainBG"
        // let strLoginPagePathName = "/Main"
        // let strLoginPagePathName = "/ImageEditor"
        // let strLoginPagePathName = "/ForgottenPassword"
        
        if (props.history.location.pathname !== strLoginPagePathName)
        {
            RoutePathLibs.Route2Path(props.history, strLoginPagePathName)
        }
        else
        {
            let objPathState = {
                LoginFailed: true
            }
            RoutePathLibs.ReplacePathState(props.history, strLoginPagePathName, objPathState)
        }
    } // end of GoToLoginPage
    
    /*===========================================
     summary: 取得 必要 書本相關資訊 流程開始
     remarks: 000 Tim 2020/11/10 Create
              001 Tim 2022/08/09 註解 App 取得資料 流程
    ===========================================*/
    function GetPrerequisiteDataProcessBegin()
    {
        console.log(COMP_NAME + ".GetPrerequisiteDataProcessBegin BookCatID:", window.gSession.App.BookCatID)

        // // 準備移除 App 取得資料 流程   Tim22.08.09
        // if (window.gSession.App.InApp)
        // {
        //     AppDataAccess.GetPrerequisiteDataFromAppProcessBegin(window.gSession.App.BookCatID)
        // }
        // else
        // {
            WebDataAccess.GetPrerequisiteDataFromWebProcessBegin(window.gSession.App.BookCatID)
        // }
    } // end of GetPrerequisiteDataProcessBegin

    /*===========================================
    summary: 取得 必要 書本相關資訊 流程結束
      param: 
    retruns: 
    remarks: 000 Tim 2020/11/10 Create
    ===========================================*/
    function GetPrerequisiteDataProcessEnd()
    {
        console.log(COMP_NAME + ".GetPrerequisiteDataProcessEnd: ")
        // // 最後要導到Lessons頁面，再把親子視窗、使用者條款 視窗先砍掉  Tim20.05.27
        // utilGlobals.ClosePCLWindow()
        // utilAAA.CloseTerms()

        // 進入 Home之前 先取得 最新的 ClassIndex Tim20.11.18
        GetClassIndex()

        let objLocationState = {
            "IsLoginAfter": true
        }

        RoutePathLibs.Route2Path(props.history, "/Home", objLocationState)
    } // end of GetPrerequisiteDataFromAppProcessEnd
    
    // function VerifyAccountEmailAfterProcess()
    // {
    //     console.log(COMP_NAME + ".VerifyAccountEmailAfterProcess")
    //     RoutePathLibs.Route2Path(props.history, "/EmailVerified")
    // }

    function GetKeys4Systems()
    {
        // const GetKeys4Systems = async () => {
        console.log(COMP_NAME + ".GetKeys4Systems")
        let objRetryFuncRef = GetKeys4Systems
        
        if (!window.navigator.onLine)
        {
            GlobalLibs.OkErrorHandler(window.gAppUI.ERR_InternetRequired_Title, window.gAppUI.ERR_InternetRequired_Msg, objRetryFuncRef)
        }
        else
        {
            let objCallbackFuncRef = GetKeys4SystemsCallback
            // let intWSServerType = NetworkLibs.WSServerTypeEnum.WS_WEB_GATEWAY
            // Open Loading mask with message
            OpenLoadingMask(window.gAppUI.MSG_LoadMask_GetKeys4Systems)
            let objCallData = {
                Func: "GetKeys4Systems",
                SysType: window.gSession.App.SysType,
                "SerialNumber": -1
            }
            // NetworkLibs.WebServiceCall(objCallData, intWSServerType, objRetryFuncRef)
            // NetworkLibs.WebServiceCall(objCallData, objRetryFuncRef)
            NetworkLibs.WebServiceCall(objCallData, objRetryFuncRef)
                .then(Response => {
                    objCallbackFuncRef(Response)
                })
        }
    } // end of GetKeys4Systems
    
    function GetKeys4SystemsCallback(Return)
    {
        console.log(COMP_NAME + ".GetKeys4SystemsCallback: ", Return)
        CloseLoadingMask()
        // you need to customize these
        let intDefaultErrNo = window.gAppUI.ERR_GetKeys4Systems_No
        let strErrorTitle = window.gAppUI.ERR_GetKeys4Systems_Title
        let strErrMsg = window.gAppUI.ERR_GetKeys4Systems_Msg
        
        if (Return.ErrNo !== NetworkLibs.NetworkLibErrorEnum.WS_SYNC_CALL_ERR_NO_SUCCESS)
        {
            switch (Return.CalledErrNo)
            {
                // // case customized error case:
                // //     break
                default:
                    // NetworkLibs.WSCallbackErrorHandler(Return.ErrNo, Return.CalledErrNo, Return.CalledErrMsg, intDefaultErrNo, strErrorTitle, strErrMsg, strRetryBackRoute, blnReLaunch, strBackRoute)
                    NetworkLibs.WSCallbackErrorHandler(Return.ErrNo, Return.CalledErrNo, Return.CalledErrMsg, intDefaultErrNo, strErrorTitle, strErrMsg)
                    break
            }
        }
        else
        {
            window.gSession.App.Keys4Systems = JSON.parse(JSON.stringify(Return.Data))
            console.log("window.gSession.App.Keys4Systems: ", window.gSession.App.Keys4Systems)
            InitLibsBegin()
        }
    } // end of GetKeys4SystemsCallback
    
    // #region Render
    function RenderMainWrapper()
    {
        return (
            <div>
                <div className={cssMain.divBG}></div>
                
                <LoadingMask ShowMask={showLoadingMask} Message={loadingMaskMessage} />
                <AlertWindow ShowAlert={showAlert} AlertObject={alertObject} HideAlertFuncRef={HideAlert}/>
                <CredentialMultiInWindow ShowCredentialMultiIn={showCredentialMultiIn} 
                        CredentialMultiInArguments={credentialMultiInArguments}/>
            </div>
        )
    } // end of RenderMainWrapper

    // Similar to Render
    return (
        <React.Fragment>
            {RenderMainWrapper()}
        </React.Fragment>
    )
    // #endregion Render
} // end of Main
export default Main